import FeatureGates from '@atlaskit/feature-gate-js-client';

export const CORE_INVITES_DRIVE_MULTI_PRODUCT_INVITES = 'core_invites_drive_multi_product_invites';

export const NOT_ENROLLED = 'not-enrolled';
export const CONTROL = 'control';
export const VARIATION = 'variation';

export const fireStatsigFeatureExposedEvent = () => {
	FeatureGates.manuallyLogExperimentExposure(CORE_INVITES_DRIVE_MULTI_PRODUCT_INVITES);
};

export const getExperimentCohort = ({ fireExposure } = { fireExposure: false }) => {
	if (FeatureGates.initializeCalled()) {
		return FeatureGates.getExperimentValue<string>(
			CORE_INVITES_DRIVE_MULTI_PRODUCT_INVITES,
			'cohort',
			NOT_ENROLLED,
			{
				fireExperimentExposure: fireExposure,
			},
		);
	}
	return NOT_ENROLLED;
};

export const isExperimentEnabled = () => getExperimentCohort({ fireExposure: false }) === VARIATION;
